<template>
  <div>
    <div class="header">
      <h2>Saved Designs</h2>
      <button class="btn btn-dark btn-block btn-add" @click="onGoToNewDesign">
        <span>New design</span><span class="plusIcon">&#65291;</span>
      </button>
    </div>
    <div class="description">
      Select a design below to continue working on it or submit it for order
      processing.
    </div>
    <div id="savedDesignContainer" v-if="designs.length">
      <SavedDesign
        :design="design"
        v-for="design in designs"
        :key="design._id"
        @delete-design="deleteDesign"
      />
      <b-pagination
        align="right"
        limit="2"
        :hide-goto-end-buttons="true"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        @change="paginate"
      >
        <template v-slot:prev-text class="prev">
          <img :src="chevronLeft" />
        </template>
        <template v-slot:next-text>
          <img :src="chevronRight" />
        </template>
      </b-pagination>
    </div>
    <div v-else id="noData">
      No data to display
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faClone } from '@fortawesome/free-regular-svg-icons'
import { namespace } from 'vuex-class'
import chevronLeft from '@/assets/images/chevron-left.svg'
import chevronRight from '@/assets/images/chevron-right.svg'
import SavedDesign from './SavedDesign'

const oauthStore = namespace('oauthStore')
const savedDesignStore = namespace('savedDesignStore')

library.add(faTrashAlt, faClone)

@Component({
  components: { SavedDesign }
})
export default class SavedDesigns extends Vue {
  @oauthStore.Getter('userId') userId
  @savedDesignStore.Action('fetchDesigns') actionFetchItems
  @savedDesignStore.Action('deleteDesign') actionDeleteDesign
  @savedDesignStore.Getter('getDesigns') designs
  @savedDesignStore.Getter('getTotalDesigns') rows

  perPage = 6
  currentPage = 1

  chevronLeft = chevronLeft
  chevronRight = chevronRight

  paginate(page) {
    this.actionFetchItems({ userId: this.userId, page, perPage: this.perPage })
  }

  created() {
    this.actionFetchItems({ userId: this.userId, perPage: this.perPage })
  }

  deleteDesign(design) {
    this.actionDeleteDesign(design).then(() => {
      this.actionFetchItems({
        userId: this.userId,
        page: this.currentPage,
        perPage: this.perPage
      })
      this.$root.$emit('reloadArtRequestTable')
    })
  }

  onGoToNewDesign() {
    this.$router.push({
      name: 'home'
    })
  }
}
</script>

<style lang="scss" scoped>
#savedDesignContainer {
  display: flex;
  flex-wrap: wrap;
  margin: -8.5px -8.5px;
}
</style>
